<template>
  <div class="mt-5">
    <div class="text-red-200 m-2 p-2 font-bold bg-red-800">{{ avisoMercadoPago }}</div>
    <div class="text-white">Ingrese el monto a recargar</div>
    <div class="text-white">Mínimo: {{ currency(importeMinimo, { decimal: "," }).format() }}</div>
    <div class="flex flex-row flex-wrap">
      <Calculadora v-on:nuevo-importe="nuevoImporte" />
    </div>
    <div v-if="menorMinimo" class="bg-red-600 text-white mt-2 mx-1">
      El importe debe ser igual o superior al mínimo
    </div>
    <button @click="recargarMercadoPago" class="bg-paleta-4 hover:bg-blue-700 text-white font-bold m-3 py-2 px-4 rounded">MercadoPago</button>
  </div>
</template>

<script>
import Calculadora from "@/components/Calculadora";
import { mapState } from "vuex";
import currency from "currency.js";

export default {
  components: {
    Calculadora
  },
  created() {
    this.$store.dispatch("obtenerTextoAppAvisoMercadoPago");
  },
  data: function() {
    return {
      importe: 0,
      currency,
      menorMinimo: false
    };
  },
  methods: {
    nuevoImporte: function(importe) {
      this.importe = importe;
    },
    recargarMercadoPago: function() {
      if (this.importe < this.importeMinimo) {
        this.menorMinimo = true;
        return;
      }
      this.$store.dispatch("generarRecargaMercadopago", { importe: this.importe });
    }
  },
  computed: {
    ...mapState({
      importeMinimo: state => state.sesion.usuario.recargaMinimaMercadoPago,
      avisoMercadoPago: state => state.textos.avisoMercadoPago
    })
  }
};
</script>
